var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(24.3px,16.2px) scale(.9,.9) translate(-43px,-44px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 50% { transform: translate(24.3px,6.2px) scale(.9,.9) translate(-43px,-44px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(24.3px,16.2px) scale(.9,.9) translate(-43px,-44px); } }\n@keyframes a1_d { 0% { d: path('M24.5,0C24.5,4,-24.5,4.5,-24.5,0C-24.5,-5,24.5,-4.5,24.5,0Z'); animation-timing-function: cubic-bezier(.4,0,.6,1); } 50% { d: path('M19.5,0C19.5,2.5,-19.5,2.5,-19.5,0C-19.5,-2.5,19.5,-2.5,19.5,0Z'); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { d: path('M24.5,0C24.5,4,-24.5,4.5,-24.5,0C-24.5,-5,24.5,-4.5,24.5,0Z'); } }\n    ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43,50.1) translate(-24.4,-21.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.3 37.5l11.7-8.4v25.2l-46 7.7l-8-24.1l13.6 4.3l12.1-16.2l16.6 11.5Z",
    transform: "translate(24.3,16.2) scale(.9,.9) translate(-43,-44)",
    style: {
      animation: "1.6s linear infinite both a0_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M24.5 0c0 4-49 4.5-49 0c0-5 49-4.5 49 0Z",
    transform: "translate(25.3,39.7) scale(.9,.9) translate(1.5,0)",
    style: {
      animation: "1.6s linear infinite both a1_d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/anime.6fd647ddb7da8594c2baa6cff1f7a86c.svg";
export { ForwardRef as ReactComponent };